<template>
  <div class="content-box">
    <div class="top_img">
     <img src="@/assets/img/mobile/home_top2.png" alt="" srcset="">
    </div>
    <div class="box-item">
      <div class="box-title">1.系统特色</div>
      <div class="box-content">
        <p class="box-intro">
         “房屋智能估价系统”已形成“电脑端+手机端”两端并行体系，为用户提供全方位、专精、客观、便捷的大数据应用产品。
        </p>
        <div class="img-content" style="margin-top: 30px;">
          <div class="img">
            <!-- <img src="@/assets/img/fwzn1_new.png" alt="" /> -->
                          <img src="@/assets/img/xtts.png" alt="">
              <img src="@/assets/img/xtts2.png" alt="">
          </div>
          <!-- <div class="img">
            <img src="@/assets/img/fwzn2.png" alt="" />
          </div> -->
        </div>
      </div>
    </div>
    <div class="box-item">
      <div class="box-title">2.估价流程</div>
      <div class="box-content">
        <!-- <p class="box-intro">
          基于六大数据板块，平台开发了一系列可视化报表，可供用户查看；同时可以根据用户需求去定制报表，可以是基于平台的数据，也可以结合其他非平台的数据，进行报表开发。
        </p> -->
        <div class="img-content">
          <!-- <div class="secTitle threeTitle">宏观经济可视化实例</div> -->
          <div class="img">
            <img src="@/assets/img/fwzn3.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="box-item">
      <div class="box-title">3.估价案例</div>
      <div class="box-content">
        <!-- <p class="box-intro">
          “房屋智能估价”应用已形成以电脑端为主、手机端为辅的“两端并行”体系，为用户提供全方位、便捷的大数据应用产品。中思拓数据平台电脑端已实现广东省房屋批量智能估价。
        </p> -->
        <div class="img-content">
          <!-- <div class="secTitle threeTitle">
            广州市天河区博雅首府xx栋xx房估价结果示例
          </div> -->
          <div class="img">
            <img src="@/assets/img/ds-3.png" style="    box-shadow: 0 3px 10px 0 #e3e3e3;" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Collateral",
};
</script>
<style lang="scss" scoped>
.top_img {
  img {
    width: 375px;
    height: auto;
  }
}

.content-box {
  .box-item {
    margin: 10px 0;
    margin-top: 0;
    background: #fff;

    .box-title {
      // margin-top: 15px;
      padding: 15px 0 0;
      height: 40px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      text-align: center;
      color: #263E8C;
    }

    .box-content {
      // width: 342px;
      // height: 115px;
      padding: 15px;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 30px;

      .box-intro {
        text-align: justify;
        text-indent: 2rem;
      }

      .img-content {

        // margin-top: 30px;
        .secTitle {
          width: 200px;
          //   height: 22px;
          font-size: 16px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 800;
          text-align: center;
          color: #1b3993;
          margin: 0px auto 15px;
        }

        .img {
          text-align: center;
          position: relative;
          width: 100%;
          height: 100%;

          & img {
            width: 100%;
            background: rgba(0, 0, 0, 0);
          }
        }

        // img {

        // }
      }
    }
  }
}
</style>